const textRepository = {
  "PCwebQuestionaiHomePage": {
    "askai": "Ask AI",
    "Length2long": "Content length is too long",
    "about": "About",
    "cancel": "Cancel",
    "extensionTab": "Extension",
    "getapp": "Get APP",
    "imageUploadDragNotice": "Drag an Image here and get solution",
    "imageUploadPasteNotice": "to paste image",
    "imageformat": "Image only allowed .PNG .JPEG .JPG",
    "mustTry": "Easy to Use",
    "norecognized": "Oh, sorry! No text was recognized. Please try again.",
    "only5mb": "Image size too large ,only allowed lase than 5MB",
    "pp": "Privacy Policy",
    "searchButton": "Search",
    "startindentified": "Question is being indentified...",
    "subjects": "Subjects",
    "tc": "Terms & Conditions",
    "userLogin": "Login",
  },
  "PCwebSEOAnswerpage": {
    "home": "Home",
  },
  "chatbox": {
    "releaeAndUpload": "Release image here to upload."
  },
  "pcweb_Home": {
    "H2_1": "Benefit from Real Homework Answers",
    "H2_1_p": "Search, upload, generate in a click. Use QuestionAI to produce premium quality AI answers you really want in 10 seconds!",
    "H3_1": "The answer had come to you in a flash",
    "H3_1_p": "QuestionAI helps to analyze the question you have uploaded in depth. And you’ll work out the answer with one-Click AI-powered creation in seconds! It’s these smart things that really make the difference - nothing beats good results that give you confidence and save you precious time.",
    "H3_2": "Take a photo to scan question and get answer? No Problem.",
    "H3_2_p": "With QuestionAI, you aren’t limited to only Text and Screenshot. Now, if you have your phone with you, you can take a picture of the puzzle that’s bothering you and upload it through our software to get the best answer.",
    "H3_3": "Restructure content with predictive AI keyword extraction algorithm.",
    "H3_3_p": "Powered by predictive AI tech, it can accurately identify the core elements of a problem based on syntax, discipline type, and neural network models (deep learning).",
    "H4_1": "Unlock The Question",
    "H4_2": "Image Recognition",
    "H4_3": "Homework Questions Analysis",
  },
  "pcweb_refuseNotice": {
    "null": "The result is empty"
  },
  "pcweb_textbook": {
    "ISBNhint": "The ISBN is a 13 digit identifier located on the back cover of the title page of your textbook.",
    "answer": "Answer",
    "homepageTitle": "Find Textbook Solutions",
    "homepageWhatisISBN": "What is ISBN? How can I find it?",
    "searchPageNum": "Search Catalog",
    "step": "Step",
    "textbookHome1": "Textbook Solutions",
    "textbookSearch1": "Search by Textbook Name or ISBN",
    "textbookSearch2": "Sorry, we couldn't find this textbook. We have recorded your request.",
  }
};
export default textRepository;